<div class="container-wrapper d-flex pl-2">
  <div class="col-md-11 pr-0 pl-0">
    <div class="container-layout">
      <div class="remaining-space">
        <div class="header">
          <div class="header-left">
            <img src="assets/icon/all_holes.svg" alt="" />
            <h4>{{ "QAQC_TAB.HOLES" | translate }}</h4>
          </div>
        </div>
          <div class="search-section">
            <div class="search-container">
              <div class="search-input-wrapper">
                <input
                  type="text"
                  class="input-text input-search-icon"
                  [placeholder]="'QAQC_TAB.SEARCH_HOLES' | translate"
                  [(ngModel)]="searchTerm"
                  (input)="onSearchChange()"
                  >
                </div>
                <button class="primary-button" (click)="onAddHole()" [title]="'QAQC_TAB.ADD_HOLE' | translate">
                  <img src="assets/icon/add-circle.svg" alt="" />
                  {{ 'QAQC_TAB.ADD_HOLE' | translate }}
                </button>

                <app-button-list
                  [items]="allColumns"
                  [selectedKeys]="visibleColumnKeys()"
                  (selectionChange)="visibleColumnKeys.set($event)"
                  iconSrc="assets/icon/settings.svg"
                  panelTitle="QAQC_TAB.COLUMNS">
                </app-button-list>
            </div>
          </div>
          <div class="holes-list-section">
            @if (holes() && holes().length > 0) {
              <app-data-table
                [data]="holesData()"
                [columns]="visibleColumns()"
                [searchTerm]="currentFilter()"
                [clickable]="true"
                [highlightedRowKey]="'name'"
                [highlightedRowValue]="highlightedHoleName()"
                (selectionLigne)="onHoleSelected($event)">
              </app-data-table>
            } @else {
              <div class="empty w-100 text-center py-5">
                <p>{{ 'QAQC_TAB.NO_HOLES_DATA' | translate }}</p>
              </div>
            }
          </div>
      </div>
    </div>
  </div>
</div>




<!-- @if (holes() && holes().length > 0) {
  <app-data-table
    [data]="holesData"
    [columns]="holesTableColumns"
    [searchTerm]="currentFilter()"
    [clickable]="true"
    (selectionLigne)="onHoleSelected($event)">
  </app-data-table>
} @else {
  <div class="empty w-100 text-center py-5">
    <p>{{ 'RECORD.NO_HOLES' | translate }}</p>
  </div>
} -->
